import React from 'react';

const PostSkeleton = () => {
  return (
    <div className="bg-white rounded-lg border p-2 md:p-3 shadow-sm w-full animate-pulse">
      {/* Header section */}
      <div className="flex items-center justify-between mb-1 md:mb-2">
        <div className="flex items-center gap-2">
          {/* Avatar skeleton */}
          <div className="w-7 h-7 md:w-8 md:h-8 bg-gray-300 rounded-full"></div>
          <div className="flex flex-col gap-1">
            {/* Name skeleton */}
            <div className="h-3 w-20 bg-gray-300 rounded"></div>
            {/* Community skeleton */}
            <div className="h-2 w-16 bg-gray-300 rounded"></div>
          </div>
        </div>
        {/* Timestamp skeleton */}
        <div className="h-2 w-12 bg-gray-300 rounded"></div>
      </div>

      {/* Content section */}
      <div className="my-1">
        {/* Text content skeleton - multiple lines */}
        <div className="space-y-1">
          <div className="h-3 w-full bg-gray-300 rounded"></div>
          <div className="h-3 w-4/5 bg-gray-300 rounded"></div>
          <div className="h-3 w-3/5 bg-gray-300 rounded"></div>
        </div>
      </div>

      {/* Media section skeleton (sometimes posts don't have media) */}
      {Math.random() > 0.5 && (
        <div className="mt-1">
          <div className="w-full max-w-sm mx-auto h-32 bg-gray-300 rounded-md"></div>
        </div>
      )}

      {/* Footer section */}
      <div className="flex items-center justify-between mt-1 md:mt-2">
        <div className="flex items-center gap-3 md:gap-4">
          {/* Like button skeleton */}
          <div className="h-4 w-8 bg-gray-300 rounded"></div>
          {/* Comment button skeleton */}
          <div className="h-4 w-12 bg-gray-300 rounded"></div>
        </div>
        {/* Delete button skeleton (for user's own posts) */}
        <div className="h-4 w-4 bg-gray-300 rounded"></div>
      </div>
    </div>
  );
};

export default PostSkeleton;
